import React from "react";
import { SpaceProps } from "styled-system";
import { Switch } from "./Switch";

export type ToggleProps = {
  value: boolean;
  onChange: (newVal: boolean) => void;
  disabled?: boolean;
  size?: "small" | "normal";
  /** Keep the track grey when on. */
  noColor?: boolean;
  "aria-label"?: string;
} & SpaceProps;

/** Kept for existing callers; new code can use Switch directly. */
export const Toggle = ({ noColor = false, ...rest }: ToggleProps) => (
  <Switch neutral={noColor} {...rest} />
);
